import { withInstall } from '@lit-element/utils'
import Badge from './src/badge.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtBadge: SFCWithInstall<typeof Badge> = withInstall(Badge)
export default LtBadge

export * from './src/badge'
export type { BadgeInstance } from './src/instance'
